import React, { Component } from 'react'

import Images from '../helpers/images'
import { heroTitle, heroCopy } from '../../lib/text'
import img from '../../assets/images/lapiquera-miel-main.jpg'

class Hero extends Component {
    render(){
        return (
            <div id="hero">
                <div className="container">
                    <div>
                        <h1>{ heroTitle }</h1>
                        <p>{ heroCopy }</p>
                    </div>
                    <div className="hero--image">
                        <Images url={ img } txt={ heroTitle } />
                    </div>
                </div>
            </div>
        )
    }
}

export default Hero